import { render, staticRenderFns } from "./VerticalMenu.vue?vue&type=template&id=5a1ab4b6&lang=html&"
import script from "./VerticalMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalMenu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports